export const PUBLIC_PIIXELS_ADDRESS = "0x6A3296B52C4D22520FC1131549DaC24Ba63eEce8";
export const VERIFIER_ADDRESS = "0x16e2F6f8D53f50E74Ab4387Bab6abf8f03BE70b1";